import * as React from "react"
import {
  Image,
} from "@chakra-ui/react"
import { brandConfig } from "./brandConfig"

interface LogoProps {
  isLight?: boolean;
  [key: string]: any;
}

// Main Logo component
export const Logo = React.forwardRef<HTMLImageElement, LogoProps>(({ isLight, ...props }, ref) => {
  return (
    <Image
      ref={ref}
      src="/logo/VC_Main Logo_RGB.png"
      alt={`${brandConfig.siteName} Logo`}
      height={{ base: "45px", sm: "55px", md: "65px", lg: "70px" }}
      objectFit="contain"
      transition="all 0.3s ease"
      filter={isLight ? "brightness(0) invert(1)" : "none"}
      _hover={{
        transform: "scale(1.02)",
      }}
      {...props}
    />
  )
})

Logo.displayName = 'Logo'

export default Logo;